<template>
  <div class="pdf-top flex just-b">
    <div>
      <div>
        <div class="flex">
          <div class="name">
            发育体能<span class="type">{{ title }}</span>报告
          </div>
          <div class="flex mt10">
            <div class="org">{{ $store.state.user.campus.name }}</div>
            <div class="year">
              {{ yearText }}
            </div>
          </div>
        </div>
        <div class="class-row flex">
          <div v-if="classroomName" class="sex">
            <span>班级：</span>
            <span class="rooms">{{ classroomName ? classroomName : '无' }}</span>
          </div>
          <div v-if="compareName" class="sex">年级：{{ compareName ? compareName : '无' }}</div>
          <div v-if="sexName" class="sex">性别：{{ sexName ? sexName : '无' }}</div>
          <div v-if="ageName" class="sex">年龄：{{ ageName ? ageName : '无' }}</div>
        </div>
      </div>
    </div>
    <img class="pdf-logo" src="@/img/evaluation/pdf-logo.png">
  </div>
</template>
<script>
import { getSemesterPeriodComboVoList } from '@/api/teachingProtection/assessment'
export default {
  props: {
    searchParams: {},
    classroomName: {},
    sexName: {},
    ageName: {},
    compareName: {},
    title: {}
  },
  data() {
    return {
      yearText: ''
    }
  },
  created() {
    console.info(this.searchParams)
    getSemesterPeriodComboVoList().then(res => {
      res.data.array.map(v => {
        if (v.code === this.searchParams.year) {
          this.yearText += v.intro
          v.children.map(q => {
            if (q.code === this.searchParams.semesterType) {
              this.yearText += q.intro
              q.children.map(z => {
                if (z.code === this.searchParams.periodType) {
                  this.yearText += z.intro
                }
              })
            }
          })
        }
      })
    })
  }
}
</script>
<style lang="scss" scoped>
.pdf-top {
  height: 113px;
  background: #ff7145;
  padding: 20px 30px;
  position: relative;
  .class-row {
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    line-height: 17px;
    margin-top: 13px;
    .rooms{
      max-width: 900px;
      text-align: left;
    }
    .sex{
      margin-right: 30px;
      display: flex;
    }
  }
  .org {
    font-weight: 600;
    font-size: 15px;
    color: #ffffff;
    line-height: 22px;
    margin-left: 37px;
  }
  .year {
    font-weight: 600;
    font-size: 15px;
    color: #ffffff;
    line-height: 22px;
    margin-left: 32px;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      height: 13px;
      background: #ffffff;
      width: 1px;
      left: -14px;
      top: 4px;
    }
  }
  .name {
    font-size: 31px;
    color: #ffffff;
    .type {
      font-weight: bold;
    }
  }
  .pdf-logo {
    width: 122px;
    height: 36px;
    position: absolute;
    right: 26px;
    top: 26px;
  }
}
</style>
